import React, { useState } from 'react';
import './TopicModal.css';
import { TableTopicService } from '../../services/TableTopicService';

interface TopicModalProps {
    IdEventTable: number;
    onConfirm: ( title: string, description: string, availabilities: { StartTime: string, EndTime: string }[]) => void;
    onCancel: () => void;
}

const TopicModal: React.FC<TopicModalProps> = ({ IdEventTable, onConfirm, onCancel }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');

    const [availabilities, setAvailabilities] = useState<{ StartTime: string, EndTime: string }[]>([]);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');

    const handleAddAvailability = () => {
        setAvailabilities([...availabilities, { StartTime: startTime, EndTime: endTime }]);
        setStartTime('');
        setEndTime('');
    };

    const handleConfirm = async () => {
        onConfirm(title, description, availabilities);
        try {
            const response = await TableTopicService.insertTableTopic(IdEventTable, title, description, availabilities);
            console.log('Inserted table topic:', response);
        } catch (error) {
            console.error('Error inserting table topic:', error);
        }
    };

    return (
        <div className="topic-modal">
            <div className="topic-modal-content">
                <button className="close-button" onClick={onCancel}>×</button>
                <h2>Add Topic</h2>
                <div>
                    <label>Title</label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Description</label>
                    <input
                        type="text"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Start Time</label>
                    <input
                        type="time"
                        value={startTime}
                        onChange={(e) => setStartTime(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>End Time</label>
                    <input
                        type="time"
                        value={endTime}
                        onChange={(e) => setEndTime(e.target.value)}
                        required
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                    <button style={{ textDecoration: 'underline', paddingBottom: '8px' }} onClick={handleAddAvailability}>Add Availability</button>
                </div>
                <ul>
                    {availabilities.map((availability, index) => (
                        <li key={index}>
                            {availability.StartTime} - {availability.EndTime}
                        </li>
                    ))}
                </ul>
                <div className="topic-modal-buttons">
                    <button onClick={handleConfirm}>Add Topic</button>
                    <button onClick={onCancel}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default TopicModal;